module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vbl-button', [_vm._v("提交")]), _c('vbl-button', {
    attrs: {
      "theme": "secondary"
    }
  }, [_vm._v("取消")]), _c('vbl-button', {
    attrs: {
      "theme": "light-secondary"
    }
  }, [_vm._v("编辑")]), _c('vbl-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("禁用")]), _c('br'), _c('br'), _c('vbl-button', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("大个提交")]), _c('vbl-button', {
    attrs: {
      "theme": "secondary",
      "large": ""
    }
  }, [_vm._v("大个取消")]), _c('vbl-button', {
    attrs: {
      "theme": "light-secondary",
      "large": ""
    }
  }, [_vm._v("大个编辑")]), _c('vbl-button', {
    attrs: {
      "large": "",
      "disabled": ""
    }
  }, [_vm._v("禁用")]), _c('br'), _c('br'), _c('vbl-button', {
    attrs: {
      "icon": "shezhi"
    }
  }, [_vm._v("提交")]), _c('vbl-button', {
    attrs: {
      "icon": "shezhi",
      "theme": "light-secondary"
    }
  }, [_vm._v("编辑")]), _c('vbl-button', {
    attrs: {
      "icon": "shezhi",
      "disabled": ""
    }
  }, [_vm._v("禁用")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-467ee149","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblButton/example/vblButtonExample.vue
// module id = 261
// module chunks = 0